// extracted by mini-css-extract-plugin
export default {"blocks":"_1Z9x7tdb1yyB7qpLvEHYb3","menu":"_2fVkvCB8q8EbEb2Dli5Ltu","content":"_22rK7xWc5HRTdC4AkslZvT"};